import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('action-message', () => import(/* webpackMode: "lazy" */'./action-message'));
